<template>
  <div
    v-show="okToShow"
    ref="container"
  >
    <pre
      :class="[`margin-0 ${hlClass}`, { 'terminal-line-start': lang === 'bash' }]"
      style="background-color: inherit; --code-font-size: var(--font-size-md)"
      @mouseup="onMouseUp"
    ><code ref="hl" /></pre>
  </div>
</template>

<script>
  import unescape from 'lodash/unescape'
  import { highlight } from './utils'

  export default {
    name: 'CodeHighlight',

    props: {
      lang: {
        type: String,
        default: 'markup'
      },
      contents: {
        type: String
      },
      noHl: {
        type: Boolean,
        default: false
      },
      code: {
        type: String
      }
    },

    emits: ['selection'],

    data() {
      return {
        okToShow: false,
        source: null
      }
    },

    computed: {
      hlClass() {
        if (this.lang && !this.noHl) {
          return `language-${this.lang}`
        } else {
          return ''
        }
      }
    },

    watch: {
      code() {
        this.highlight()
      },
      contents() {
        this.highlight()
      }
    },

    async mounted() {
      this.highlight()
      this.okToShow = true
    },

    updated() {
      this.highlight()
    },

    methods: {
      async highlight() {
        let source = this.code

        this.$refs.hl.innerText = source

        if (this.lang === 'bash') {
          source = unescape(source)
        }

        this.source = source

        this.$nextTick(async () => {
          try {
            if (this.noHl) {
              this.$refs.hl.innerText = this.source
            } else {
              this.$refs.hl.innerHTML = highlight(this.source, this.lang)
            }
          } catch (e) {
            // noop, failed to find the $refs.hl most likely
          }
        })
      },

      onMouseUp() {
        const selectionText = window.getSelection().toString()

        if (selectionText.length > 0) {
          this.$emit('selection', selectionText)
        }
      }
    }
  }
</script>
